<template>
  <div class="view bio" v-if="profile" :extended="extended">
    <div class="bio-name">
      <a class="back" @click="$router.back()">&lt; zurück</a>
      <h1 v-html="profile.name.replace(/ /g, '<br>')"></h1>
      <div class="bio-description" v-html="profile.description"></div>
      <button class="btn" @click="extended = !extended">Expertise</button>
      <div class="bio-socials">
        <a :href="profile.socials.linkedin" target="_blank"><i class="fab fa-linkedin-in"></i></a>
        <a :href="profile.socials.xing" target="_blank"><i class="fab fa-xing"></i></a>
        <a :href="`mailto:${profile.socials.email}`" target="_blank"><i class="far fa-envelope"></i></a>
        <a :href="`tel:${profile.socials.phone}`" target="_blank">
          <i class="fas fa-mobile-alt"></i>
          <div class="tooltip">{{profile.socials.phone}}</div>
        </a>
      </div>
    </div>
    <div :style="{backgroundImage: `url(${profile.picture})`}" class="profile-picture"></div>
    <div class="bio-content" v-if="extended" v-html="profile.bio"></div>
    <div class="bio-quote" v-else>
      <div class="bio-quote-text">„{{profile.quote}}”</div>
      <div class="bio-quote-author">{{profile.name}}</div>
    </div>
    <div class="bio-description mobile" v-html="profile.description"></div>
    <div class="bio-content mobile" v-html="profile.bio"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'bio',
  computed: {
    ...mapGetters({
      profiles: 'getProfiles'
    })
  },
  data() {
    return {
      profile: null,
      extended: false
    }
  },
  mounted: function() {
    const profile = this.profiles.find(p => p.id === this.$route.params.name)
    if(!profile) this.$router.push('/about-us')
    else this.profile = profile
    this.$store.commit('setTransition', false)
  }
}
</script>

<style scoped>
.back {
  position: absolute;
  top: 10.18vh;
  left: 12.08vw;
  font-size: 1.3vh;
  font-weight: 500;
  color: #fff;
  letter-spacing: .4em;
  z-index: 3;
}

.bio {
  position: absolute;
  top: 8.15vh;
  left: 7.81vw;
  right: 7.08vw;
  height: 72.77vh;
  display: flex;
  justify-content: space-between;
}

.bio:before,
.bio:after {
  content: '';
  position: absolute;
  top: 12.96vh;
  height: 48.33vh;
  background: rgba(82, 82, 102, .23);
}

.bio:before {
  left: 12.19vw;
  width: 32.3vw;
}

.bio:after {
  width: 16.66vw;
  left: 44.49vw;
  transition: width .16s ease-in-out, .16s transform .16s ease-in-out;
}

.bio[extended]:after {
  width: 43.56vw;
  transform: translateX(-1.5vw);
}

.bio .profile-picture {
  position: absolute;
  top: 0;
  left: 27.29vw;
  width: 31vw;
  height: 72.77vh;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 0 28px rgba(0,0,0,.5);
  z-index: 1;
}

.bio .bio-name,
.bio .bio-quote {
  position: relative;
  flex-shrink: 0;
  z-index: 1;
}

.bio .bio-name {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  width: 25.1vw;
  text-align: right;
  padding-bottom: 6.85vh;
}

.bio .bio-name h1 {
  margin: 0 0 3.51vh 0;
  width: 16.15vw;
  font: 400 2.66vw/1.22 'Exodus Demo St';
  color: #FFD675;
  text-align: left;
}

.bio .bio-name .bio-description {
  font-weight: 300;
  line-height: 1.875;
  letter-spacing: .05em;
  margin-bottom: 1.48vh;
  min-height: 16.11vh;
  font-size: 1.34vh;
}

.bio .bio-name .btn {
  flex-shrink: 1;
  flex-grow: 0;
}

.bio .bio-name .bio-socials {
  margin-top: 3.33vh;
}

.bio .bio-name .bio-socials a {
  position: relative;
  display: inline-flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  margin-left: .625vw;
}

.bio .bio-name .bio-socials a .tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  border: 1px solid rgba(255, 214, 117, 0.23);
  padding: 8px 16px;
  white-space: nowrap;
  font-size: 1.3vh;
  opacity: 0;
  transform: translateY(-10%);
  transition: all .16s ease-in;
  pointer-events: none;
}

.bio .bio-name .bio-socials a:hover .tooltip {
  opacity: 1;
  transform: none;
  pointer-events: all;
}

.bio .bio-name .bio-socials a .tooltip:after,
.bio .bio-name .bio-socials a .tooltip:before {
	bottom: 100%;
	left: 88%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
}

.bio .bio-name .bio-socials a .tooltip:after {
	border-color: transparent;
	border-bottom-color:#0A1612;
	border-width: 6px;
	margin-left: -6px;
}

.bio .bio-name .bio-socials a .tooltip:before {
	border-color: transparent;
	border-bottom-color: rgba(255, 214, 117, 0.23);
	border-width: 7px;
	margin-left: -7px;
}

.bio .bio-quote {
  width: 32.5vw;
  color: #FFD675;
  font-weight: 300;
  align-self: flex-end;
  margin-bottom: 39.07vh;
}

.bio .bio-quote .bio-quote-text {
  font-style: italic;
  font-size: 1.04vw;
  letter-spacing: .2em;
  line-height: 1.35;
}

.bio .bio-quote .bio-quote-author {
  padding-right: 10.94vw;
  text-align: right;
  margin-top: 1.85vh;
  letter-spacing: .05em;
}

.bio .bio-quote .bio-quote-author:after {
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 2px;
  background: #FFD675;
  margin-left: 22px;
}

.bio .bio-content {
  width: 25.47vw;
  padding-top: 15.4vh;
  font-weight: 300;
  line-height: 1.875;
  letter-spacing: .05em;
  padding-right: 1.2vw;
  z-index: 2;
}

.bio .bio-content.mobile,
.bio .bio-description.mobile {
  display: none;
}

.bio .bio-content >>> p {
  margin: 0 0 2.96vh;
}

.bio .bio-content >>> h6 {
  font-size: inherit;
  color: #FFD675;
  margin: 0 0 1.48vh;
}

@media screen and (max-width: 1024px) {
  .back {
    display: none;
  }
  .bio {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    width: auto;
    height: auto;
    flex-flow: column nowrap;
  }
  .bio .bio-name {
    position: absolute;
    width: auto;
    left: 0;
    right: 0;
    padding: 88% 30px 0;
    z-index: 3;
  }
  .bio .bio-name:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -12px;
    height: 76px;
    background: rgba(82, 82, 102, 0.23);
  }
  .bio .bio-name h1 {
    position: relative;
    width: auto;
    text-align: right;
    margin: 0 0 12px;
    font-size: 34px;
    z-index: 2;
  }
  .bio .bio-name .btn,
  .bio .bio-name .bio-description,
  .bio:before,
  .bio:after {
    display: none;
  }
  .bio .profile-picture {
    position: relative;
    width: 100%;
    left: 0;
    height: auto;
    padding-top: 132%;
  }
  .bio .bio-name .bio-socials {
    margin: 0;
  }
  .bio .bio-name .bio-socials a {
    margin-left: 24px;
  }
  .bio .bio-quote {
    width: auto;
    padding: 36px 30px;
    margin: 0;
  }
  .bio .bio-quote .bio-quote-text {
    font-size: 16px;
    line-height: 1.6875;
  }
  .bio .bio-quote .bio-quote-author {
    padding: 0;
    font-size: 13px;
  }
  .bio .bio-content.mobile,
  .bio .bio-description.mobile {
    display: block;
    width: auto;
    padding: 0 30px;
    font-size: 16px;
    line-height: 1.875;
    letter-spacing: .05em;
    background: rgba(82, 82, 102, 0.23);
  }
  .bio .bio-description.mobile {
    padding-top: 30px;
    font-size: inherit;
  }
  .bio .bio-content.mobile {
    padding-bottom: 30px;
  }
  .bio .bio-content >>> h6,
  .bio .bio-content >>> p {
    margin: 36px 0 0;
  }
}
</style>

